import { render, staticRenderFns } from "./ViewAppeal.vue?vue&type=template&id=8469425a&scoped=true&lang=pug"
import script from "./ViewAppeal.vue?vue&type=script&lang=js"
export * from "./ViewAppeal.vue?vue&type=script&lang=js"
import style0 from "./ViewAppeal.vue?vue&type=style&index=0&id=8469425a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8469425a",
  null
  
)

export default component.exports